import {
  API_TYPES,
  type GetWorkerRequirementsResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { type ModalShiftData } from "@src/appV2/redesign/Shift/types";
import { type AxiosError } from "axios";

import { mergeWorkerRequirementWithIncludedResources } from "../mergeWorkerRequirementWithIncludedResources";
import { type WorkerRequirement } from "../types";
import { useGetWorkerRequirements } from "../useGetWorkerRequirements";

interface UseGetBlockingRequirementsForShiftProps {
  shift?: ModalShiftData;
  qualification?: string;
}

export function useGetBlockingRequirementsForShift(
  props: UseGetBlockingRequirementsForShiftProps,
  options: UseGetQueryOptions<GetWorkerRequirementsResponse, AxiosError, WorkerRequirement[]> = {}
) {
  const { shift, qualification } = props;
  const { workplace, attributes: { end, qualification: shiftQualification } = {} } = shift ?? {};

  return useGetWorkerRequirements(
    {
      filter: {
        workplaceIds: [workplace?.id ?? ""],
        qualifications: [qualification ?? shiftQualification ?? ""],
        expiresAt: { gte: end ?? "" },
        requiredForBooking: true,
        isValid: false,
      },
      include: [API_TYPES.requirements],
    },
    {
      select: mergeWorkerRequirementWithIncludedResources,
      ...options,
      enabled: isDefined(shift) && (options.enabled ?? true),
    }
  );
}
